import { render, staticRenderFns } from "./UserInviteSummary.vue?vue&type=template&id=d56f4aa0&scoped=true&"
import script from "./UserInviteSummary.vue?vue&type=script&lang=js&"
export * from "./UserInviteSummary.vue?vue&type=script&lang=js&"
import style0 from "./UserInviteSummary.vue?vue&type=style&index=0&id=d56f4aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56f4aa0",
  null
  
)

export default component.exports